import { put, takeEvery } from 'redux-saga/effects';
import {
  authClearGlobalFormErrors,
  authSubmitResetPasswordForm,
  authSubmitSignInForm,
  authSubmitSignUpForm,
} from '../actions';
import { SIGN_IN_FORM } from '../SignInForm';
import { SIGN_UP_FORM } from '../SignUpForm';
import { RESET_PASSWORD_FORM } from '../ResetPasswordForm';
import { getType } from 'typesafe-actions';

const actionTypeToFormName = {
  [getType(authSubmitSignInForm)]: SIGN_IN_FORM,
  [getType(authSubmitSignUpForm)]: SIGN_UP_FORM,
  [getType(authSubmitResetPasswordForm)]: RESET_PASSWORD_FORM,
};

function* clearGlobalFormErrors(action: any) {
  const formName = actionTypeToFormName[action.type];

  if (formName) {
    yield put(authClearGlobalFormErrors(formName));
  }
}

export default function* globalFormErrorsSaga() {
  yield takeEvery(
    [getType(authSubmitSignInForm), getType(authSubmitSignUpForm), getType(authSubmitResetPasswordForm)],
    clearGlobalFormErrors,
  );
}



// WEBPACK FOOTER //
// ./src/containers/Auth/saga/globalFormErrorsSaga.ts